import {IView} from '@gongxigames/framework/core';

export interface IBackgroundView extends IView {
    playTransition(name: string): void;
}
